<template>
    <div class="text-center">
        <span v-if="intStatus == 3" class="ApronStatus bg-red d-inline-block w-100 color-white">{{StatusToString(intStatus)}}</span>
        <span v-else-if="intStatus == 2" class="ApronStatus bg-orange d-inline-block w-100 color-white">{{StatusToString(intStatus)}}</span>
        <span v-else-if="intStatus == 4" class="ApronStatus bg-red d-inline-block w-100 color-white">{{StatusToString(intStatus)}}</span>
        <span v-else-if="intStatus == 1" class="ApronStatus bg-green d-inline-block w-100 color-white">{{StatusToString(intStatus)}}</span>
        <span v-else-if="intStatus == 5" class="ApronStatus bg-yellow d-inline-block w-100 color-white">{{StatusToString(intStatus)}}</span>
        <span v-else-if="intStatus == 6" class="ApronStatus bg-yellow d-inline-block w-100 color-MediumGrey">{{StatusToString(intStatus)}}</span>
        <span v-else-if="intStatus == 0" class="ApronStatus bg-grey d-inline-block w-100 color-white">{{StatusToString(intStatus)}}</span>

        <!--<span v-else class="ApronStatus bg-green d-inline-block w-100 color-white">{{StatusToString(intStatus)}}</span>-->
    </div>
</template>

<script>

    export default {
        name: 'ApronStatus',
        components: {
        },
        props: {
            intStatus: Number
        },
        data: function () {

            return {

            }

        },
        methods: {
			StatusToString: function (intStatus) {
                if (intStatus == 0) {
                    return 'Unknown'
                }
                else if (intStatus == 1) {
					return this.$t('general.ok')
                } else if (intStatus == 2) {
					return this.$t('general.statusInspection')
                } else if (intStatus == 3) {
					return this.$t('general.statusAway')
                } else if (intStatus == 4) {
					return this.$t('general.statusDiscarded')
                } else if (intStatus == 5) {
					return this.$t('general.statusAcceptance')
                } else if (intStatus == 6) {
					return this.$t('general.statusOkForNow')
                }
                else {
                    return 'Unknown'
                }
            }
        },
        mounted: function () {

        },
        updated: function(){

        }
    }
</script>
